export default __webpack_public_path__ + "static/media/LitFest Logo.a43b8d7e.png";